module.exports = __webpack_public_path__ + "static/img/5-7.8d5d8444.png";